const TOKEN_KEY = "bloxx_auth_token";
import { discardStartupRead } from "./startupReads";
import type { User } from "./xano";

export async function verifySession(token: string): Promise<User> {
  const started = performance.now();
  const base = new URL(import.meta.env.VITE_XANO_AUTH_URL.replace(/\/?$/, "/"), window.location.origin);
  const response = await fetch(new URL("auth/me", base), { headers: { Authorization: `Bearer ${token}` }, signal: AbortSignal.timeout(15000) });
  performance.measure('bloxx:auth-response', { start: started, end: performance.now(), detail: { status: response.status } });
  if (!response.ok) throw new XanoError(response.status, "Session could not be verified.", null);
  const value = await response.json();
  if (!value || !Number.isSafeInteger(value.id) || value.id <= 0 || typeof value.email !== "string" ||
      (value.first_name !== undefined && typeof value.first_name !== "string") ||
      (value.last_name !== undefined && typeof value.last_name !== "string")) throw new XanoError(502, "The identity service returned an invalid profile.", null);
  return value as User;
}

export const tokenStore = {
  get(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  },
  set(token: string) {
    discardStartupRead();
    localStorage.setItem(TOKEN_KEY, token);
  },
  clear() {
    discardStartupRead();
    localStorage.removeItem(TOKEN_KEY);
  },
};

export class XanoError extends Error {
  status: number;
  payload: unknown;

  constructor(status: number, message: string, payload: unknown) {
    super(message);
    this.status = status;
    this.payload = payload;
  }
}
